var _g, _path, _rect, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.942 -6.10352e-05H15.6908C10.6882 -6.10352e-05 6.63281 4.05533 6.63281 9.05791V48.3092C6.63281 53.3117 10.6882 57.3671 15.6908 57.3671H54.942C59.9446 57.3671 64 53.3117 64 48.3092V9.05791C64 4.05533 59.9446 -6.10352e-05 54.942 -6.10352e-05Z",
    fill: "#B9E2FC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0175 10H10.2849C4.60471 10 0 14.6047 0 20.2849V52.0175C0 57.6977 4.60471 62.3024 10.2849 62.3024H42.0175C47.6977 62.3024 52.3024 57.6977 52.3024 52.0175V20.2849C52.3024 14.6047 47.6977 10 42.0175 10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2076_3791",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19.9999,
    width: 31.7467,
    height: 31.7467,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2076_3791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6032 46.4555V37.196H36.4535V46.4555H31.6032ZM23.4463 46.4555V25.291H28.2963V46.4555H23.4463ZM15.2891 46.4555V31.9049H20.1394V46.4555H15.2891Z",
    fill: "#0D5DA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.4ed9d99c981e219c7a3c8241cd4cbece.svg";
export { ForwardRef as ReactComponent };